var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.993 13.9951C20.4825 12.5356 21.9919 10.7863 21.9919 8.49707C21.9919 7.0389 21.4127 5.64045 20.3816 4.60936C19.3505 3.57828 17.952 2.99902 16.4939 2.99902C14.7345 2.99902 13.4949 3.49885 11.9955 4.99831C10.496 3.49885 9.25645 2.99902 7.49707 2.99902C6.0389 2.99902 4.64045 3.57828 3.60936 4.60936C2.57828 5.64045 1.99902 7.0389 1.99902 8.49707C1.99902 10.7963 3.49849 12.5456 4.99796 13.9951L11.9955 20.9926L18.993 13.9951Z",
    stroke: "white",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9954 4.99829L9.03646 7.95724C8.83335 8.15887 8.67215 8.39871 8.56215 8.66292C8.45214 8.92713 8.39551 9.2105 8.39551 9.49669C8.39551 9.78289 8.45214 10.0663 8.56215 10.3305C8.67215 10.5947 8.83335 10.8345 9.03646 11.0361C9.85617 11.8559 11.1657 11.8858 12.0354 11.1061L14.1047 9.2068C14.6233 8.73616 15.2986 8.47545 15.999 8.47545C16.6994 8.47545 17.3746 8.73616 17.8933 9.2068L20.8523 11.8659",
    stroke: "white",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9941 14.9954L15.9941 12.9954",
    stroke: "white",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9951 17.9944L12.9951 15.9944",
    stroke: "white",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/Family.5fd257eb90e7e977f6e98f32e8507c14.svg";
export { ForwardRef as ReactComponent };